'use client';



const AppsLayout = ({ children }) => {
  return (
    <div className="">
      {/* <div className="absolute inset-0 pointer-events-none z-30">
      <div className="mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
      <div
        className={`pointer-events-none absolute top-[500px] -left-20 -rotate-45 rounded-full w-[600px] h-[400px]  bdg-red-400 bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-2-transparent-1))] blur-3xl opacity-15`}
      ></div>
      <div
        className={`pointer-events-none absolute top-[300px] -right-20 -rotate-45 rounded-full w-[600px] h-[400px]  bdg-red-400 bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-2-transparent-1))] blur-3xl opacity-15`}
      ></div>
    </div> */}
      {children}
    </div>
  );
};

export default AppsLayout;
